// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "footer[data-v-0735e5bb]{background:#333;color:white}footer h2[data-v-0735e5bb]{color:white}footer[data-v-0735e5bb] a{color:white;text-decoration:underline}footer[data-v-0735e5bb] h4{color:white;margin:3px 0 -12px}\n", ""]);
// Exports
module.exports = exports;
